﻿

// ------------------------------------------------------------------------- //
// #LOGIN
// ------------------------------------------------------------------------- //

window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.login = (function () {
    var priv = {};

    /**
     * Private initialization method
     */
    priv.init = function () {
        priv.start();
        priv.validate();
    };

    priv.start = function () {
        if ($(".js-page-identifier-login").length) {
            var htmlEl = document.getElementsByTagName("html");

            if (htmlEl.length > 0) {
                htmlEl[0].className += " iam-html";
            }

            $("#email").on("invalid",
                function (event) {
                    event.preventDefault();
                    console.log(event);
                    $("#error-message-label").removeClass("hidden");
                });
        }
    };

    priv.validate = function () {

        $("#changePasswordSubmit").click(function (e) {

            var validator = $("#changePasswordForm").validate({
                rules: {
                    newPassword: {
                        required: true,
                        regex: /^[A-Za-z0-9\d=!\-@.!#$%&()+={}[\:;'<>?,\]_\/*]*$/
                    },
                    retypeNewPassword: {
                        equalTo: "#newPassword"
                    }
                },
                messages: {
                    newPassword: {
                        required: "Du måste fylla i alla fälten för att kunna byta lösenord.",
                        regex: "Lösenordet är inte av rätt typ. Se krav för nytt lösenord."
                    },
                    retypeNewPassword: "Lösenorden stämmer inte överens med varandra. Vänligen försök igen."
                },
                errorLabelContainer: ".js-validate-error",
                wrapper: "li"
            });
            if (validator.form()) {
                $("#changePasswordSubmit").submit();
            } else {
                console.log("Failed");
            }
        });

        $("#resetPasswordSubmit").click(function (e) {
            e.preventDefault(e);

            var validator = $("#loginform").validate({
                rules: {
                    password: {
                        required: true,
                        regex: /^[A-Za-z0-9\d=!\-@.!#$%&()+={}[\:;'<>?,\]_\/*]*$/
                    },
                    confirmpassword: {
                        equalTo: "#password"
                    }
                },
                messages: {
                    password: {
                        required: "Du måste fylla i alla fälten för att kunna byta lösenord.",
                        regex: "Lösenordet är inte av rätt typ. Se krav för nytt lösenord."
                    },
                    confirmpassword: "Lösenorden stämmer inte överens med varandra. Vänligen försök igen."
                },
                errorLabelContainer: ".js-validate-error",
                wrapper: "li"
            });
            if (validator.form()) {
                $("#loginform").submit();
            } else {
                console.log("Failed");
            }
        });
    };

    // Initialize module
    $(function () {
        priv.init();
    });

})();
